import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  titles: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Attiva le notifiche WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]: 'Chiamate automatiche per ordini in sospeso',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Orari di apertura',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Posizione',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identità del ristorante',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Tempo di ritiro',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Tempo di consegna',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Credenziali del personale',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importa menu',
    [ONBOARDING_GUIDE_STEPS.Favourites]: 'Preferiti',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Articoli esauriti',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Codici promo',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Galleria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]: 'Aggiungi logo e colore principale del ristorante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: 'Ordina volantini',
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Crea storefront',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Abilita ordini live',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: 'Abilita Google Business',
  },
  descriptions: {
    [ONBOARDING_GUIDE_STEPS.WhatsApp]: 'Verifica se il titolare/contatto ha WhatsApp',
    [ONBOARDING_GUIDE_STEPS.Voice]:
      'Verifica che il numero del ristorante sia corretto per ricevere le chiamate automatiche e non perdere ordini',
    [ONBOARDING_GUIDE_STEPS.OpenTimes]: 'Imposta gli orari di apertura del ristorante',
    [ONBOARDING_GUIDE_STEPS.Location]: 'Imposta la posizione del ristorante',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Imposta il tipo di ristorante e le cucine mostrate nel negozio',
    [ONBOARDING_GUIDE_STEPS.PickupTime]: 'Imposta le impostazioni del tempo di ritiro',
    [ONBOARDING_GUIDE_STEPS.DeliveryTime]: 'Configura le impostazioni dei tempi di consegna',
    [ONBOARDING_GUIDE_STEPS.OrderSettingsStaffCredentials]: 'Configura le credenziali del personale',
    [ONBOARDING_GUIDE_STEPS.ImportMenu]: 'Importa il menu da un provider di terze parti',
    [ONBOARDING_GUIDE_STEPS.Favourites]:
      'Segna 4 articoli come preferiti. Chiedi al ristorante quali sono i 4 piatti più popolari',
    [ONBOARDING_GUIDE_STEPS.SoldOutItems]: 'Configura il comportamento degli articoli esauriti',
    [ONBOARDING_GUIDE_STEPS.PromoCodes]: 'Configura i codici promozionali',
    [ONBOARDING_GUIDE_STEPS.Gallery]: 'Aggiorna la galleria',
    [ONBOARDING_GUIDE_STEPS.LogoAndPrimaryColor]:
      'Prendi il logo dal ristorante o dalla pagina su Lieferando. Salvalo da lì. Scegli il colore più presente nel logo del ristorante',
    [ONBOARDING_GUIDE_STEPS.OrderFlyers]: "Modifica il design del volantino e crea l'ordine",
    [ONBOARDING_GUIDE_STEPS.CreateStorefront]: 'Crea la vetrina e modifica il sito web se necessario',
    [ONBOARDING_GUIDE_STEPS.EnableLiveOrders]: 'Attiva gli ordini live («!solo alla data di lancio!»)',
    [ONBOARDING_GUIDE_STEPS.GoogleBusiness]: "Collega l'account Google Business",
  },
  buttons: {
    mark_as_complete: 'Segna come completato',
  },
  toasts: {
    failed_to_save_changes: 'Salvataggio delle modifiche non riuscito',
  },
};
